/** True as soon as the target mode is "exclusive" and it was not already the persisted mode — the
 * moment the plan calls "the switch," not every subsequent save while a configuration stays exclusive. */
function isSwitchToExclusiveMode(mode: string, currentMode: string | null): boolean {
	return mode === 'exclusive' && currentMode !== 'exclusive';
}

export default isSwitchToExclusiveMode;
